import React from 'react';
import PropTypes from 'prop-types';
import { noop } from '../../../../../lib/utilities';
import { Cashback100 } from './product/cashback_100';
import { ProductPriceRow } from './product/product_price_row';
import { TypeRow } from './product/type_row';
import getTranslatedText from '../../../helper/get_translated_text';
import { featureFlags } from '../../../../_constants/feature_flags';
// TODO: Temporary disabled matesrates
import { ProductPriceMatesRates } from './product_price_mates_rates';
import API from '../../../../API/api';
import onRemoveCrossSellClick from '../actions/on_remove_cross_sell_click';
import { ProductBadge } from '../../product_revamp/tile/product_badge';
import { RowTwoCells } from './row_two_cells';

function getProductTypeTranslationKey(productType) {
  return getTranslatedText('product-type-' + productType);
}

export function Product(props) {
  const { buy4pay3, cashback100, clearance, cartProducts } = props;
  const hasDeal = featureFlags.FEATURE_TYRE_DEALS && (buy4pay3 || cashback100);
  const discountPrice = props.quantity * props.pricePerItem - props.setPrice;
  const productSetPriceRows = [];
  let mostPopularVehicleElem = '';
  let choiceAwardBadges = '';
  let badges = [];
  let isNewProduct = false;
  const selectedCartProduct = cartProducts ? cartProducts.find((c) => c.id === props.productId) : false;

  if (selectedCartProduct) {
    badges = [...selectedCartProduct.badge];
    isNewProduct = selectedCartProduct.isNewProduct;

    if (selectedCartProduct.productBadges && selectedCartProduct.productBadges.length) {
      choiceAwardBadges = [selectedCartProduct.productBadges[0]].map((b) => (
        <img style={{ height: '90px' }} className="choice-award-badge" alt={'choice-award-badge'} src={b.imageUrl} />
      ));
    }

    if (selectedCartProduct.mostPopularVehicle) {
      mostPopularVehicleElem = (
        <div style={{ position: 'absolute' }} className="product-badge product-badge--black most-popular-vehicle-badge">
          <span>Popular for</span>
          <span className="most-popular-vehicle-badge-text">
            {selectedCartProduct.mostPopularVehicle.make} {selectedCartProduct.mostPopularVehicle.model}
          </span>
        </div>
      );
    }
  }

  productSetPriceRows.push(
    <TypeRow
      label={getProductTypeTranslationKey(props.type)}
      type={props.type}
      showDetails={props.showDetails}
      quantity={props.quantity}
      pricePerItem={props.pricePerItem}
      currencyIsoCode={props.currencyIsoCode}
      hasPaddingBottom={!hasDeal}
      key="TypeRow"
      clearance={clearance}
      productId={props.productId}
      cartProductType={props.cartProductType}
      lightContentAvailable={props.lightContentAvailable}
      onRemoveCrossSellClick={onRemoveCrossSellClick}
    />,
  );

  productSetPriceRows.push(
    <ProductPriceRow
      brand={props.brand}
      name={props.name}
      type={props.type}
      description={props.description}
      quantity={props.quantity}
      pricePerItem={props.pricePerItem}
      currencyIsoCode={props.currencyIsoCode}
      hasBorder={false}
      showDetails={props.showDetails}
      hasPaddingBottom={!hasDeal}
      onShowProductDetailsClick={props.onShowProductDetailsClick}
      isMpsProduct={props.isMpsProduct}
      cartProducts={props.cartProducts}
      productId={props.productId}
      lightContentAvailable={props.lightContentAvailable}
      cartProductType={props.cartProductType}
      productLinksTitles={props.productLinksTitles}
      isFittingAvailable={props.isFittingAvailable}
      shipments={props.shipments}
      productUrl={props.productUrl}
      choiceAwardBadges={choiceAwardBadges}
      key="Product"
    />,
  );

  if (badges.length) {
    productSetPriceRows.push(
      <RowTwoCells
        key={`row-two-cells-promo-${props.productId}`}
        name={'cart-item sidebar__row--no-top-border'}
        left={
          <ProductBadge
            product={{
              badges: badges || [],
              buy4for3: buy4pay3,
              clearance: clearance,
              manufacturer: props.brand,
              isNewProduct,
            }}
            additionalNewProductStyles={props.showDetails ? { top: '-160px' } : { top: '-65px' }}
          />
        }
        right={<span></span>}
      />,
    );
  }

  if (props.showDetails && mostPopularVehicleElem) {
    productSetPriceRows.push(
      <RowTwoCells
        key={`row-two-cells-most-popular-${props.productId}`}
        name={'cart-item sidebar__row--no-top-border cart-quick-view-most-popular-badge'}
        left={mostPopularVehicleElem}
        right={<span></span>}
        colspan={3}
      />,
    );
  }

  if (featureFlags.FEATURE_TYRE_DEALS && props.cashback100) {
    productSetPriceRows.push(
      <Cashback100 discount={discountPrice} currencyIsoCode={props.currencyIsoCode} key="Cashback100" />,
    );
  }

  // if (props.showDetails && featureFlags.FEATURE_FRIEND_BUY && false === props.buy4pay3) {
  //     productSetPriceRows.push(
  //         <ProductPriceMatesRates
  //             price={props.setPrice / 2}
  //             currencyIsoCode={props.currencyIsoCode}
  //             onMatesRatesLearnMoreClick={props.onMatesRatesLearnMoreClick}
  //             key="AllItemsPriceMatesRates"
  //         />
  //     );
  // }

  return productSetPriceRows;
}

Product.propTypes = {
  productId: PropTypes.string,
  type: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buy4pay3: PropTypes.bool.isRequired,
  cashback100: PropTypes.bool.isRequired,
  quantity: PropTypes.number.isRequired,
  pricePerItem: PropTypes.number.isRequired,
  setPrice: PropTypes.number.isRequired,
  currencyIsoCode: PropTypes.string.isRequired,
  onMatesRatesLearnMoreClick: PropTypes.func,
  onShowProductDetailsClick: PropTypes.func,
  showDetails: PropTypes.bool,
  isMpsProduct: PropTypes.bool,
  cartProducts: PropTypes.arrayOf(PropTypes.object),
  clearance: PropTypes.bool,
  lightContentAvailable: PropTypes.bool,
};

Product.defaultProps = {
  showDetails: true,
  onMatesRatesLearnMoreClick: noop,
  onShowProductDetailsClick: noop,
  isMpsProduct: false,
  cartProducts: [],
};
